import React from "react";
import {
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer,
    Paper,
    Typography,
    Pagination,
    Box,
} from "@mui/material";

const PayInTable = ({ filteredData, classes = {}, message, page, pageSize, currentPage }) => {
    if (message) {
        return <Typography variant="h6" align="center">{message}</Typography>;
    }

    return (
        <Box sx={{ mt: 3 }}>
            <TableContainer
                component={Paper}
                sx={{
                    maxWidth: "100%",
                    overflowX: "auto",
                    borderRadius: "12px",
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                }}
            >
                <Table>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: "#027BFE" }}>
                            {["Sr. No.", "Txn ID", "UTR No", "Date", "PayIn Amount", "Amount", "Status"].map((header) => (
                                <TableCell key={header} sx={{ color: "white", fontWeight: "bold" }}>
                                    {header}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredData.length > 0 ? (
                            filteredData.map((row, index) => (
                                <TableRow
                                    key={row.txnid}
                                    sx={{
                                        backgroundColor: index % 2 === 0 ? "#f9f9f9" : "white",
                                        "&:hover": { backgroundColor: "#f5f5f5" },
                                    }}
                                >
                                    <TableCell>{currentPage * pageSize + index + 1}</TableCell>
                                    <TableCell>{row.txnid}</TableCell>
                                    <TableCell>{row.easepayid}</TableCell>
                                    <TableCell>{row.addedon}</TableCell>
                                    <TableCell>{row.netAmountDebit || "N/A"}</TableCell>
                                    <TableCell>{row.amount}</TableCell>
                                    <TableCell
                                        sx={{
                                            fontWeight: "bold",
                                            color:
                                                row.status === "success"
                                                    ? "green"
                                                    : row.status === "failure"
                                                        ? "red"
                                                        : "black",
                                        }}
                                    >
                                        {row.status === "success" ? "Successful" : "Failed"}
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={7} align="center">
                                    No Data Available
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};


export default PayInTable;
